<!--
 * @Version      : V1.0
 * @Date         : 2025-05-21 09:27:24
 * @fileName     :
 * @Description  : 我的电费
-->
<template>
  <div class="customerProfile-con px-20 py-20 border-box">
    <el-card class="box-card">
      <div class="query-con">
        <el-form :inline="true" :model="formInline" ref="ruleForm" class="demo-form-inline">
          <el-form-item label="电费收款名称" porp="collectionName">
            <el-input v-model="formInline.collectionName" placeholder="电费收款名称"></el-input>
          </el-form-item>
          <el-form-item label="客户" porp="customerId">
            <el-select clearable v-model="formInline.customerId" filterable placeholder="请选择客户">
              <el-option v-for="item in customerOption" :key="item.id" :label="item.customerName"
                :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="收款合同" porp="contractReceivePaymentId">
            <el-select @change="getLedgerContractList" filterable clearable v-model="formInline.contractReceivePaymentId" placeholder="请选择收款合同">
              <el-option v-for="item in receivableContractOption" :key="item.id" :label="item.contractName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="queryData">查询</el-button>
            <el-button @click="resetData('ruleForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>

    <div class="operate py-20 border-box">
    </div>
    <div class="table-con">
      <tableComponent :columns="columns" :tableData="dataList" @preSizeChange="childSizeChange"
        @preCurrentChange="childCurrentChange" :loading="loading" :pagination="pagination">
        <template #ifUploadInvoiceSlot="{ row }">
          <el-tag :type="row.ifUploadInvoice == 0 ? 'danger' : 'success'" effect="dark">
            {{ row.ifUploadInvoice == 1 ? '是' : '否' }}
          </el-tag>
        </template>
        <template #collectionStatusSlot="{ row }">
          <div>
            <el-tag :type="formatterState(row.collectionStatus, 'contract').type" effect="dark">{{
              formatterState(row.collectionStatus,'contract').text }}</el-tag>
          </div>
        </template>
        <template #recordAuditStatusSlot="{ row }">
          <div>
            <el-tag :type="auditProcessStatus(row.recordAuditStatus).type" effect="dark">{{
              auditProcessStatus(row.recordAuditStatus).text }}</el-tag>
          </div>
        </template>
        <template #operate="{ row }">
          <div>
            <el-button type="text" @click="details(row)">详情</el-button>
            <el-button type="text" @click="openReviewer(row)" v-if="row.recordAuditStatus == 0">审核</el-button>
          </div>
        </template>
      </tableComponent>
    </div>
    <my-contract-details ref="myComtractRefs" @initQueryData="queryData" :title="detailsT" :status="preStatus"
      :toExamine="toExamine" @parReviewer="reviewer"></my-contract-details>
  </div>
</template>

<script>
import myContractDetails from './components/myContractDetails.vue'
import tableComponent from '@/components/tableComponent/index.vue'
import { formatterState,auditProcessStatus } from '@/utils/index'
import { queryPageForLedgerListApi } from '@/api/receivableContract‌/index'
import { querySupplierInfoListApi, queryBasicOwnersListApi } from '@/api/basicInfo/index'
import { queryPageForAuditApi } from '@/api/electricityFeeCollection/index'
export default {
  components: {
    tableComponent,
    myContractDetails
  },
  data() {
    return {
      loading: false,
      dialogFormVisible: false,
      toExamine: false,
      detailsT: '我的电费详情',
      formInline: {
        collectionName: "",
        contractReceivePaymentId: "",
        ownerId: "",
        customerId: ""
      },
      dataList: [],
      ownerOption: [],
      customerOption: [],
      receivableContractOption:[],
      preStatus: '',
      columns: [
        {
          id: 0,
          title: "序号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "58px",
          keyName: "i", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 22,
          title: "电费收款名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "180px",
          keyName: "collectionName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 1,
          title: "收款合同名称", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "180px",
          keyName: "contractReceivePaymentName", // 数据的属性值
          align: "left",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        
        {
          id: 3,
          title: "楼盘信息", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "buildingInformation", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 21,
          title: "机房信息", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "computerRoomInformation", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 23,
          title: "电表位置", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "electricityMeterLocation", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 4,
          title: "电表号", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "electricityMeterNo", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 5,
          title: "用电量", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "electricityConsumption", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 6,
          title: "原价(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "originalPrice", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 7,
          title: "收取价(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "100px",
          keyName: "chargingPrice", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 8,
          title: "原价总金额(元)", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "originalPriceTotal", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 9,
          title: "收取价总金额", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "120px",
          keyName: "chargingPriceTotal", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        // {
        //   id: 10,
        //   title: "利润", // 标题名称
        //   isSort: false, // 是否展示排序按钮
        //   sortState: "",
        //   width: "90px",
        //   keyName: "signingDate", // 数据的属性值
        //   align: "center",
        //   slotName: "", // 插槽名,为空字符串时不使用
        // },
        {
          id: 11,
          title: "电费收款状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "collectionStatus", // 数据的属性值
          align: "center",
          slotName: "collectionStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 2,
          title: "审核状态", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "recordAuditStatus", // 数据的属性值
          align: "center",
          slotName: "recordAuditStatusSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 17,
          title: "是否上传发票", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "90px",
          keyName: "ifUploadInvoice", // 数据的属性值
          align: "center",
          slotName: "ifUploadInvoiceSlot", // 插槽名,为空字符串时不使用
        },
        {
          id: 18,
          title: "上传发票时间", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "142px",
          keyName: "uploadInvoiceTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 14,
          title: "提交人", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "70px",
          keyName: "createByName", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 15,
          title: "创建日期", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          width: "145px",
          keyName: "createTime", // 数据的属性值
          align: "center",
          slotName: "", // 插槽名,为空字符串时不使用
        },
        {
          id: 16,
          title: "操作", // 标题名称
          isSort: false, // 是否展示排序按钮
          sortState: "",
          fixed: "right",
          width: "200px",
          keyName: "", // 数据的属性值
          align: "center",
          slotName: "operate", // 插槽名,为空字符串时不使用
        }
      ],
      pagination: {
        pageCount: 7, //总页数
        total: 0, //总条目数
        pageSize: 1,//当前页条数
        pageSizes: [10, 20, 100]
      }
    }
  },
  mounted() {
    this.getOwnersList();
    this.getCurtomer();
    this.getLedgerContractList()
    this.queryData()
  },
  methods: {
    formatterState,
    auditProcessStatus,
    //查询
    queryData() {
      this.initData()
    },
    //初始化查询
    initData(item = {}) {
      let params = {
        pageNum: "1",
        pageSize: "10",
        query: {
          params: {
            collectionName: this.formInline.collectionName,
            customerId: this.formInline.customerId,
            ownerId: this.formInline.ownerId, //我方单位ID
          },
          contractReceivePaymentId: this.formInline.contractReceivePaymentId,
        },
        ...item
      }
      this.loading = true;
      queryPageForAuditApi(params).then(res => {
        this.loading = false;
        this.toExamine = false;
        if (res.code == 200) {
          this.dataList = res.data.rows;
          this.pagination.total = res.data.total;
        }
      })
    },
    childSizeChange(page) {
      this.initData({ pageSize: page })
    },
    childCurrentChange(value) {
      this.initData({ pageNum: value })
    },
    //重置搜索form
    resetData(formName) {
      this.formInline.collectionName = "";
      this.formInline.customerId = "";
      this.formInline.ownerId = "";
      this.formInline.contractReceivePaymentId = "";
      this.$nextTick(() => {
        this.initData()
      })

    },
    details(row) {
      this.preStatus = 'view'
      this.detailsT = '我的电费详情'
      this.toExamine = false;
      this.$refs.myComtractRefs.openDrawer(row)
    },
     //审核
    openReviewer(row) {
      this.toExamine = true;
      this.preStatus = 'view'
      this.detailsT = '我的电费审核详情'
      this.$store.dispatch('getRecordId', row.recordId)
      this.$store.dispatch('getApiType', 'setFinElectricityCollectionAuditRecordApi')
      this.$refs.myComtractRefs.openDrawer(row)
    },
    //审核完刷新页面
    reviewer() {
      this.initData()
    },
    //获取客户档案
    getCurtomer() {
      let params = {
        customerName: ""
      }
      querySupplierInfoListApi(params).then(res => {
        if (res.code == 200) {
         this.customerOption = res.data;
        }
      })
    },
    //我方负责单位下拉
    getOwnersList() {
      let params = {
        unitName: ""
      }
      queryBasicOwnersListApi(params).then(res => {
        if (res.code == 200) {
          this.ownerOption = res.data;
        }
      })
    },
    //查询收款合同台账
    getLedgerContractList(v = '') {
      let params = {
        params: {
          contractName:v,
        }
      }
      queryPageForLedgerListApi(params).then(res => {
        if (res.code == 200) {
          this.receivableContractOption = res.data;
        }
      })
    },
  }
}
</script>

<style scoped lang="scss">
.customerProfile-con {
  background: #f7f4f4;

  .box-card {
    width: 100%;
  }

  .operate {}
}
</style>
